// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from'./store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n'
import req from './common/golrobaxios.js'
// import VueLazyload from 'vue-lazyload'
Vue.prototype.req = req
Vue.use(VueI18n)
Vue.use(VueAxios,axios);
// Vue.use(VueLazyload)
Vue.config.productionTip = false
/* eslint-disable no-new */
var qs = require("qs");
Vue.prototype.qs = qs;
Vue.prototype.$apiUrl="//"+config.root
// Vue.prototype.JDUrl="//jd.vvc.tw"
// Vue.prototype.TMUrl="//tm.uuelo.com"
Vue.prototype.Edition=config.version

if(!localStorage.getItem("languageAll")){
  localStorage.setItem("languageAll",'zh')
}

const i18n = new VueI18n({
  locale:localStorage.getItem("languageAll"), // 语言标识
  messages: {
    'zh': require('./data/zh'),
    'en': require('./data/en'),
    'ko': require('./data/ko')
  }
})
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js